import { JSX } from 'react';

// types
import { IDefaultCsProps, TComponent } from '@/lib/contentstack-sdk/types';

// helpers
import RenderComponents from '@/components/helpers/cms/RenderComponents';

export interface ITmLandingCSProps extends IDefaultCsProps {
  block: ITmLandingProps;
}

export interface ITmLandingProps {
  body: TComponent[];
  _content_type_uid: 'landing';
  uid: string;
  locale: string;
}

export const TmLanding = ({ block }: ITmLandingCSProps): JSX.Element => {
  const { uid, locale } = block;
  return (
    // offset for the navigation on regular templates that don't have the header
    <div>
      {block.body.map((blk, index) => {
        const { _content_type_uid } = blk;
        return (
          <RenderComponents
            isPage={false}
            showAbaForm={false}
            locale={locale || 'en-US'}
            entryUid={uid || ''}
            contentTypeUid={_content_type_uid}
            key={index}
            body={[blk]}
          />
        );
      })}
    </div>
  );
};
